import { create } from 'zustand';

// Platform operator session is represented by an HttpOnly cookie. The boolean is
// deliberately not a credential and is reset when the browser session ends.
export const usePlatformAuth = create((set) => ({
  authenticated: false,
  setAuthenticated: (authenticated) => set({ authenticated }),
  logout: () => {
    set({ authenticated: false });
  },
}));
